<template>
  <div class="user-center">
    <pcHeader></pcHeader>
    <div class="content-box">
      <div class="cont-name">个人中心</div>
      <div class="user-info-box">
        <a-layout>
          <a-layout-sider>
            <!-- icon-Outpatient-Department -->
            <a-menu
              v-model="current"
              theme="dark"
              mode="inline"
            >
              <a-menu-item
                v-for="item in menus"
                :key="item.url"
                @click="goNext(item.url)"
              >
                <icon-font :type="item.iconName" />
                <span>{{ item.name }}</span>
              </a-menu-item>
            </a-menu>
          </a-layout-sider>
          <a-layout>
            <a-layout-content>
              <router-view />
            </a-layout-content>
          </a-layout>
        </a-layout>
      </div>
    </div>
  </div>
</template>
<script>
import pcHeader from "@/components/Header";
import { getPcJkdaUrl } from "@/api/index";
import store from "@/store/index";
export default {
  components: {
    pcHeader,
  },
  data() {
    return {
      current: ["/user-center/personal-home"],
      menus: [
        {
          url: "/user-center/personal-home",
          iconName: "icon-yonghu1",
          name: "个人主页",
        },
        {
          url: "/user-center/register",
          iconName: "icon-Outpatient-Department",
          name: "挂号记录",
        },
        {
          url: "/user-center/follow-disease",
          iconName: "icon-bingdu",
          name: "关注的疾病",
        },
        {
          url: "/user-center/follow-doctor",
          iconName: "icon-yisheng1",
          name: "关注的医生",
        },
        {
            url:'/user-center/follow-department',
            iconName:'icon-keshi',
            name: "关注的科室",
        },
        {
          url: "/user-center/follow-hospital",
          iconName: "icon-yiyuan",
          name: "关注的医院",
        },
        {
          url: "/user-center/self-medical",
          iconName: "icon-pingjia",
          name: "自我病例",
        },
        {
          url: "/user-center/self-test",
          iconName: "icon-pingjia",
          name: "自我检测",
        },
        {
          url: "/user-center/evaluate-list",
          iconName: "icon-pingjia",
          name: "我的评价",
        },
        {
          url: "/user-center/user-setting",
          iconName: "icon-shezhi",
          name: "设置",
        },
        {
          url: "/user-center/healthy-card",
          iconName: "icon-yinhangqia",
          name: "电子健康卡管理",
        },
        {
          url: "/user-center/health-record",
          iconName: "icon-browser",
          name: "健康档案浏览器",
        },
        // liulanqi
        {
          url: "/user-center/news-center",
          iconName: "icon-xiaoxi",
          name: "消息中心",
        },
        {
          url: "/user-center/report-refer",
          iconName: "icon-baogao-copy",
          name: "报告查询",
        },
        {
          url: "/user-center/question",
          iconName: "icon-wenjuandiaocha",
          name: "问卷调查",
        },
        {
          url: "/user-center/health-tools",
          iconName: "icon-gongjuxiang",
          name: "健康工具",
        },
      ],
      // 健康档案浏览器地址
      url: this.base_url+"/browserHealthRecord/index/index?data=",
    };
  },
  created() {
    this.menus.forEach((item) => {
      if (this.$route.path.indexOf(item.url) >= 0) {
        this.current[0] = item.url;
      }
    });
  },
  watch: {
    $route() {
      this.menus.forEach((item) => {
        if (this.$route.path.indexOf(item.url) >= 0) {
          this.current[0] = item.url;
        }
      });
    },
  },
  methods: {
    //前往下个页面
    async goNext(val) {
      if (val == "/user-center/health-record") {
        // this.$store.commit("showLoading");
        let res = await getPcJkdaUrl();
        if (res.code == 200) {
          location.href = this.url + res.data;
          // setTimeout(()=>this.$store.commit("hideLoading"),2000)
        } else {
          this.$message.error(res.message);
          this.$route.go(0);
          // this.$store.commit("hideLoading");
        }
        return;
      }
      this.$router.push({
        path: val,
        query: {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.user-center {
  .content-box {
    width: 1200px;
    margin: auto;

    .cont-name {
      font-size: 26px;
      font-weight: 400;
      color: #3385ed;
      line-height: 42px;
      border-bottom: 2px solid #3385ed;
      padding-bottom: 15px;
    }

    .user-info-box {
      margin-top: 23px;

      .ant-layout-sider {
        background: #fff;
      }

      .ant-menu-dark {
        // width: 200px;
        background: rgba(51, 133, 237, 0.08);
        // height: 610px;

        .ant-menu-item {
          font-size: 16px;
          font-weight: 400;
          color: #999999;

          .anticon {
            font-size: 20px;
          }
        }
      }

      .ant-layout-content {
        padding-left: 40px;
        background: #fff;
      }
    }
  }
}
</style>
